import axios from 'axios';
//import jsonp from 'jsonp';
import * as querystring from 'querystring';
//import fetchJsonp from 'fetch-jsonp';
//import jsonp from 'axios-jsonp-pro';

/*
1. Login to federation service in staging environment

https://basf-carecreations-staging.aa-g.de/saml_cc/login?ReturnUrl=https://basf-carecreations-staging.aa-g.de/
patrick.brill.fr@basfqa.com
!Dksbbfnat4

2. Get Token 5ce2bf45-5399-4a3f-b1cb-7846873a8205

https://basf-carecreations-staging.aa-g.de/sitefinity/public/services/User/UserService.svc/GetCurrentUser

{"Access_Token":"7a82cd0f-3e47-4c6f-a315-4036031a6d15",
"Basket":null,
"CanUseOrderSample":true,
"Country":"France",
"Email":"patrick.brill.fr@basfqa.com",
"FederationLogin":true,
"Firstname":"Patrick",
"IsLoggedIn":true,
"LastUpdated":"\/Date(1569010226460+0200)\/",
"Lastname":"Brill-FR",
"LoginMessage":"successful",
"Region":"FRA",
"SessionID":"lr2jbzqsshmfh3gf1j401x41",
"UserId":"0a675dde-697a-44c5-b4b8-0822f6ac8247",
"UserRights":["CanUseOrderSample"],
"WALogin":false}

3. Do GET Requests

*/

//https://basf-carecreations-staging.aa-g.de/sitefinity/public/services/EmollientsJockeyToolService.svc/GetUserByUserId/d516b4c4-5322-4bbc-8f68-0bee80fe45ae/c62c4f4b-13af-4696-a0f9-3284a0989063
const getBaseURL = () => {
  return ["staging", "localhost"].some(str => window.location.href.indexOf(str) > -1)
    ? "https://basf-carecreations-staging.aa-g.de"
    : "https://www.carecreations.basf.com";
}
const servicePath = "/sitefinity/public/services/EmollientsJockeyToolService.svc";
const services = [
  "GetCurrentUser",
  "GetUserByUserId",
  "GetEmollients",
  "GetEmollients/Normalized",
  "GetEmollients/Classified",
  "Track"
]

const getServiceURL = (service, token = window.auth_token, uid = window.user_id, pID = "") => {
  const baseURL = getBaseURL();
  console.log(baseURL);
  if(!service) {
    return `${baseURL}${servicePath}/${services[0]}`;
  } else {
    return `${baseURL}${servicePath}/${service}${pID && "/"+pID}${uid && "/"+uid}${token && "/"+token}/`;
  }
};

export const get = service => {
  const endpoint = getServiceURL(services[service]);
  return axios.get(endpoint).then(response => {
    return response.data;
  }).catch(error => error);
}

export const post = (service, obj) => {
  const baseURL = getBaseURL();
  const endpoint = `${baseURL}${servicePath}/${services[service]}/`;
  //axios.defaults.withCredentials = true;
  return axios.post(endpoint, JSON.stringify(obj), /*{
    headers: { 'Content-Type': 'application/json' }
}*/).then(response => {
    return response.data;
  }).catch(error => error);
}
